import { atom } from "jotai";

export interface IQuestionnaireStepperPercentageStore {
  currentPercentage: number;
}

const initialState: IQuestionnaireStepperPercentageStore = {
  currentPercentage: 0,
};

export const QuestionnaireStepperPercentageStore = atom<IQuestionnaireStepperPercentageStore>(initialState);
